var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuotes(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(-202 -3046.999)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base",
    width: 40,
    height: 40,
    transform: "translate(202 3046.999)",
    fill: "#fff",
    opacity: 0.001
  }), /*#__PURE__*/React.createElement("path", {
    id: "icon_quote",
    d: "M15.659,30h0V24.86q0-.041,0-.082V17.927a4,4,0,0,0-4-4H0V24.778a4,4,0,0,0,4,4h7.66a4,4,0,0,0,4-3.891ZM.012,13.924H7.3a8.18,8.18,0,0,1,.468-2.169,8.565,8.565,0,0,1,2.682-3.731,9.029,9.029,0,0,1,1.025-.716c1.658-1,3-2.763,2.651-4.665A2.978,2.978,0,0,0,10.244.183,16.507,16.507,0,0,0,5.732,2.767,15.469,15.469,0,0,0,.887,9.507,14.762,14.762,0,0,0,.012,13.924ZM33.929,30h0V17.924a4,4,0,0,0-4-4H18.27V24.775a4,4,0,0,0,4,4h7.66a4,4,0,0,0,4-3.891ZM18.282,13.924h7.291a8.185,8.185,0,0,1,.468-2.169,8.565,8.565,0,0,1,2.683-3.731,9.019,9.019,0,0,1,1.025-.716c1.658-1,3-2.763,2.651-4.665A2.978,2.978,0,0,0,28.514.183,16.508,16.508,0,0,0,24,2.767a15.47,15.47,0,0,0-4.845,6.739A14.763,14.763,0,0,0,18.282,13.924Z",
    transform: "translate(205 3051.997)",
    fill: "#ffc051",
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotes);
export default __webpack_public_path__ + "static/media/quotes.81b2c7ba60bd374e781e0e5df1666539.svg";
export { ForwardRef as ReactComponent };